import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.9785 4.2085H23.0004V6.33835H19.7302V17.6726H23.0004V19.7918H13.9785V17.6726H17.1751V6.33835H13.9785V4.2085Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.4751 16.2064H4.66974L3.62875 19.7919H1L5.98412 4.20862H8.22382L13.1238 19.7919H10.5056L9.4751 16.2064ZM5.31116 14.0017H8.85472L7.09871 7.83686L5.31116 14.0017Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }